<template>
  <v-dialog v-model="internalDialog" max-width="600px">
    <v-card>
      <!-- Header -->
      <v-card-title>
        <div>Additional Stock</div>
        <v-select
          v-model="selectedDate"
          :items="selectOptions"
          item-text="text"
          item-value="value"
          label="Pilih Tanggal"
          outlined
          dense
          class="mt-2"
          style="width: 100%;"
        ></v-select>
      </v-card-title>
      <v-divider></v-divider>

      <!-- Body yang bisa di-scroll -->
      <v-card-text class="scrollable-body">
        <!-- List Produk -->
        <div
          v-for="(product, index) in filteredPOProducts"
          :key="index"
          class="mb-3 pt-3"
        >
          <v-row>
            <v-col cols="6">
              {{ product.product_code }} {{ product.product_name }}
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="stocks[product.product_code]"
                label="Stok"
                type="number"
                dense
                outlined
                :disabled="isDisabled"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <!-- Footer -->
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Batal</v-btn>
        <v-btn color="primary" @click="save" :disabled="isDisabled">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AdditionalAddDialog",
  props: {
    dialog: Boolean,
    defaultDays: Array,
    weekDates: Array,
    filteredPOProducts: Array,
    outletcode: String
  },
  data() {
    return {
      internalDialog: this.dialog,
      selectedDate: null,
      stocks: {},
      isDisabled: true,
    };
  },
  watch: {
    dialog(val) {
      this.internalDialog = val;
      if (val) {
        this.resetForm();
      }
    },
    internalDialog(val) {
      this.$emit("update:dialog", val);
    },
    selectedDate(newVal) {
      if (newVal) {
        this.checkStockAvailability(newVal);
      }
    },
  },
  computed: {

    selectOptions() {
      return this.defaultDays.map((item, idx) => ({
        text: `${item.value} (${this.weekDates[idx].format})`,
        value: this.weekDates[idx].format
      }));
    }
  },
  methods: {
    async checkStockAvailability(date) {
      try {
        const response = await this.$store.dispatch('po/getExistPO', {
          outletcode: this.outletcode,
          date: date,
        });

        if (response.data.status === 'success') {
          if (response.data.data.is_exist) {
            this.isDisabled = false;
          }else{
            this.$store.commit('setSnackbar', {saveError: true, errorMessage: "PO belum ada, silakan tambahkan PO terlebih dahulu"});
            this.isDisabled = true;
          }
        } else {
          this.$store.commit('setSnackbar', {
            saveError: true,
            errorMessage: response.data.message
          });
        }
      } catch (err) {
        this.$store.commit('setSnackbar', {
          saveError: true,
          errorMessage: 'Gagal memuat data detail.'
        });
      }
    },
    save() {
      if (!this.selectedDate) {
        this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Silahkan pilih tanggal terlebih dahulu"});
        return;
      }
      
      const stockData = this.filteredPOProducts.map(product => ({
        product_code: product.product_code,
        stock: Number(this.stocks[product.product_code] || 0)
      }));

      this.$emit("save", {
        outletcode: this.outletcode,
        selectedDate: this.selectedDate,
        stocks: stockData
      });

      this.close();
    },
    close() {
      this.internalDialog = false;
    },
    resetForm() {
      this.selectedDate = null;
      this.stocks = {};
    }
  }
};
</script>

<style scoped>
.scrollable-body {
  max-height: 300px;
  overflow-y: scroll;
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>